<template>
	<div class="containerMain">
		<title-bar :topTitle="true" />
		<div class="col inner" v-if="schoolSummary && schoolProgress">
			<title-bar title="Progreso" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio" />
			<title-bar :title="category.name" :percentage="category.percentage" percentageTitle="Promedio Categoría" :categoryId="categoryId" />
			<div class="col full">
				<div class="row between innerRubric">
				<progress-chart v-for="question in progressionReport.questions" :key="question.id" :categoryId="categoryId" :data="question.graphData" :title="question.name" :percentage="question.percentage" />
			</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';
export default {
	props: ['categoryId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		schoolProgress () {
			return this.$store.state.school.progress;
		},
		category () {
			if (!this.schoolSummary) return this.schoolSummary;
			else return this.schoolSummary.coachingCategories.find((category) => {
				return category.id == this.categoryId;
			});
		},
		progressionReport () {
			if (!this.category) return [];
			this.category.questions.forEach((coachingQuestion) => {
				coachingQuestion.graphData = {
					labels: this.schoolProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == this.categoryId) {
								category.questions.forEach((question) => {
									if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
								});
							}
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets: [{
						data: this.schoolProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == this.categoryId) {
									category.questions.forEach((question) => {
										if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
									});
								}
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.schoolProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
				return coachingQuestion;
			});
			return this.category;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/routes/school/CategoryProgress.vue